import { Fragment, useState, useEffect } from "react";
import "./header_left.scss";
import images from "../../../../../../utilities/images/images";
import { isEmpty } from "../../../../../../custom_utilities/custom_useful_functions";
import PreferenceSelectionModal from "../../../../user_utility_components/preference_selection_modal/preference_selection_modal";
import axios from "axios";
import {
  url_5,
  url_8,
  url_32,
} from "../../../../../../custom_utilities/api_services";

//Redux
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import uiActions from "../../../../../../redux/ui/action";
import authActions from "../../../../../../redux/auth/action";
import userPreferenceActions from "../../../../../../redux/user_preference/action";

const HeaderLeft = (props) => {
  let {
    userPreference,
    userData,
    setUser,
    setUserPreference,
    startLoading,
    finishLoading,
    batchId,
    redirectToDashboardOnUpdate = true,
    showBatchLabel = true,
    buttonText = "Update your Course",
    buttonClassName = "",
    buttonIcon = images.m2_rgtArr,
  } = props;
  let { batchDetails } = userPreference;

  const history = useHistory();

  const [isPreferenceModalOpen, setIsPreferenceModalOpen] = useState(false);
  const [isPreferenceLoading, setIsPreferenceLoading] = useState(false);

  const [state, setState] = useState({
    userDetails: {},
    userPreference: {
      target_id: "",
      class_id: "",
      course_id: "",
      batch_id: "",
    },
    targets: {},
    classes: {},
    courses: {},
    batches: {},
    isTargets: false,
    isCourses: false,
    isClasses: false,
  });

  useEffect(() => {
    setUserData();
  }, []);

  useEffect(() => {
    if (!isEmpty(state.targets) && !state.isTargets) {
      getClasses();
      setState((prevState) => ({ ...prevState, isTargets: true }));
    }
  }, [state.targets]);

  useEffect(() => {
    if (!isEmpty(state.classes) && !state.isClasses) {
      getCourses();
      setState((prevState) => ({ ...prevState, isClasses: true }));
    }
  }, [state.classes]);

  useEffect(() => {
    if (!isEmpty(state.courses) && !state.isCourses) {
      getBatches();
      setState((prevState) => ({ ...prevState, isCourses: true }));
    }
  }, [state.courses]);

  const handlePreferenceModal = async () => {
    if (isPreferenceLoading) return;

    setIsPreferenceLoading(true);
    setIsPreferenceModalOpen(true);

    try {
      const returnedResponse = await getUserProfile();
      if (returnedResponse.result !== 1) {
        setIsPreferenceModalOpen(false);
        return;
      }

      setUserPreference({
        targetDetails: returnedResponse.data.apiData.UsertargetDetail,
        classDetails: {
          class_id: returnedResponse.data.apiData.class_id,
          class: returnedResponse.data.apiData.class,
        },
        courseDetails: returnedResponse.data.apiData.targets,
        batchDetails: {
          batch_id: returnedResponse.data.apiData.batch_id,
          batch: returnedResponse.data.apiData.batch,
        },
      });

      setUserPreferences_1(returnedResponse.data.apiData);

      const returnedResponse_2 = await getTargets(false);
      if (returnedResponse_2.result !== 1) {
        setIsPreferenceModalOpen(false);
        return;
      }

      setState((prevState) => ({
        ...prevState,
        targets: returnedResponse_2.data.apiData,
      }));
      getClasses();
    } catch (error) {
      console.log(error);
      setIsPreferenceModalOpen(false);
    } finally {
      setIsPreferenceLoading(false);
    }
  };

  const getUserProfile = async () => {
    try {
      const response = await axios.get(url_8);

      if (response.data.status === 200) {
        return { result: 1, data: { apiData: response.data.data } };
      } else {
        return { result: 0, data: { apiData: {} } };
      }
    } catch (error) {
      finishLoading();
      console.log(error);
      return { result: 0, data: { apiData: {} } };
    }
  };

  const setUserData = () => {
    setState((prevState) => ({ ...prevState, userDetails: userData }));
  };

  const setUserPreferences_1 = (apiData) => {
    if (apiData.UsertargetDetail.length) {
      setState((prevState) => ({
        ...prevState,
        userPreference: {
          ...prevState.userPreference,
          target_id: parseInt(apiData.UsertargetDetail[0].target_id, 10),
          course_id: parseInt(apiData.targets[0].course_id, 10),
          class_id: parseInt(apiData.class_id, 10),
          batch_id: parseInt(apiData.batch_id, 10),
        },
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        userPreference: {
          ...prevState.userPreference,
          target_id: "",
          course_id: "",
          class_id: "",
          batch_id: "",
        },
      }));
    }
  };

  const getTargets = async (useGlobalLoader = true) => {
    if (useGlobalLoader) startLoading();
    try {
      const response = await axios.get(url_5);

      if (response.data.status === 200) {
        if (useGlobalLoader) finishLoading();
        return { result: 1, data: { apiData: response.data.data } };
      }

      if (useGlobalLoader) finishLoading();
      return { result: 0, data: { apiData: {} } };
    } catch (error) {
      if (useGlobalLoader) finishLoading();
      console.log(error);
      return { result: 0, data: { apiData: {} } };
    }
  };

  const getClasses = () => {
    let targets = { ...state.targets };
    let userPreference = { ...state.userPreference };
    let classes = {};

    if (!isEmpty(targets)) {
      classes = targets.target.find((element) => {
        return element.target_id === parseInt(userPreference.target_id);
      });
    }

    if (!isEmpty(classes)) {
      setState((prevState) => ({ ...prevState, classes: classes }));
      getCourses();
    }
  };

  const getCourses = () => {
    let classes = { ...state.classes };
    let userPreference = { ...state.userPreference };
    let courses = {};

    if (!isEmpty(classes)) {
      courses = classes.classes.find((element) => {
        return element.class_id === parseInt(userPreference.class_id);
      });
    }

    if (!isEmpty(courses)) {
      setState((prevState) => ({ ...prevState, courses: courses }));
      getBatches();
    }
  };

  const getBatches = () => {
    let courses = { ...state.courses };
    let userPreference = { ...state.userPreference };
    let batches = {};

    if (!isEmpty(courses)) {
      batches = courses.course.find((element) => {
        return element.course_id === parseInt(userPreference.course_id);
      });
    }

    if (!isEmpty(batches)) {
      setState((prevState) => ({ ...prevState, batches: batches }));
    }
  };

  const handleChangeTarget = (event) => {
    let { value } = event.target;
    let targets = { ...state.targets };
    let classes = {};

    classes = targets.target.find((element) => {
      return element.target_id === parseInt(value);
    });

    if (!isEmpty(classes)) {
      setState((prevState) => ({
        ...prevState,
        classes: classes,
        courses: {},
        batches: {},
        userPreference: {
          ...prevState.userPreference,
          target_id: parseInt(value),
          class_id: "",
          course_id: "",
          batch_id: "",
        },
      }));
    }
  };

  const handleChangeClass = (event) => {
    let { value } = event.target;
    let classes = { ...state.classes };
    let courses = {};

    courses = classes.classes.find((element) => {
      return element.class_id === parseInt(value);
    });

    if (!isEmpty(courses)) {
      setState((prevState) => ({
        ...prevState,
        courses: courses,
        batches: {},
        userPreference: {
          ...prevState.userPreference,
          class_id: parseInt(value),
          course_id: "",
          batch_id: "",
        },
      }));
    }
  };

  const handleChangeCourse = (event) => {
    let { value } = event.target;
    let courses = { ...state.courses };
    let batches = {};

    batches = courses.course.find((element) => {
      return element.course_id === parseInt(value);
    });

    if (!isEmpty(batches)) {
      if (batches.batch.length) {
        const selectedBatch = batches.batch.find(
          (element) => element.is_selected
        );
        const batchId = selectedBatch
          ? parseInt(selectedBatch.batch_id)
          : parseInt(batches.batch[0].batch_id);

        setState((prevState) => ({
          ...prevState,
          batches: batches,
          userPreference: {
            ...prevState.userPreference,
            course_id: parseInt(value),
            batch_id: batchId,
          },
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          batches: batches,
          userPreference: {
            ...prevState.userPreference,
            course_id: parseInt(value),
            batch_id: "",
          },
        }));
      }
    }
  };

  const handleChangeBatch = (event) => {
    let { value } = event.target;

    setState((prevState) => ({
      ...prevState,
      userPreference: {
        ...prevState.userPreference,
        batch_id: parseInt(value),
      },
    }));
  };

  const upadateCourseApi = async (data) => {
    try {
      const response = await axios.post(url_32, data);
      if (response.status === 200) {
        if (response.data.status === 200) {
          return {
            result: 1,
            data: {
              message: response.data.message,
              apiData: response.data.data,
            },
          };
        } else {
          return { result: 0, data: { message: response.data.message } };
        }
      } else {
        return { result: 0, data: { message: "Something went wrong!!!" } };
      }
    } catch (error) {
      return {
        result: 0,
        data: { message: error.response.statusText },
      };
    }
  };

  const validCheckUserPreference = (userPreference) => {
    let valid = true;

    Object.values(userPreference).forEach((val) => {
      val === "" && (valid = false);
    });

    return valid;
  };
  useEffect(() => {
    if (batchId) {
      handleUpdateCourse();
    }
  }, [batchId]);

  const handleUpdateCourse = async () => {
    let userDetails = { ...state.userDetails };
    let userPreference = { ...state.userPreference };

    if (window.navigator.onLine) {
      if (validCheckUserPreference(userPreference)) {
        let data = {
          user_target_id: userPreference.target_id,
          class_id: userPreference.class_id,
          course_id: userPreference.course_id,
          batch_id: userPreference.batch_id,
        };

        startLoading();
        let returnedResponse = await upadateCourseApi(data);

        if (returnedResponse.result === 1) {
          finishLoading();
          setUser(returnedResponse.data.apiData);

          setUserPreference({
            targetDetails: returnedResponse.data.apiData.UsertargetDetail,
            classDetails: {
              class_id: returnedResponse.data.apiData.class_id,
              class: returnedResponse.data.apiData.class,
            },
            courseDetails: returnedResponse.data.apiData.targets,
            batchDetails: {
              batch_id: returnedResponse.data.apiData.batch_id,
              batch: returnedResponse.data.apiData.batch,
            },
          });
          setIsPreferenceModalOpen(false);
          handleCloseModal();
          if (
            history.location.pathname === "/user_dashboard" ||
            history.location.pathname === "/dashboard"
          ) {
            // window.onbeforeunload = null;
            window.onbeforeunload = null;
            window.location.reload();
          } else if (redirectToDashboardOnUpdate) {
            history.push({
              pathname: "/user_dashboard",
            });
          }
        } else {
          finishLoading();
          alert(returnedResponse.data.message);
        }
      } else {
        alert("Please select target, course, class and batch carefully");
      }
    } else {
      alert("Please check your internet connection");
    }
  };

  const handleCloseModal = () => {
    setIsPreferenceModalOpen(false);
    setIsPreferenceLoading(false);
    setState((prevState) => ({
      ...prevState,
      userPreference: {
        ...prevState.userPreference,
        target_id: "",
        course_id: "",
        class_id: "",
        batch_id: "",
      },
      targets: {},
      courses: {},
      classes: {},
      batches: {},
      isTargets: false,
      isClasses: false,
      isCourses: false,
    }));
  };
  return (
    <Fragment>
      <div className="headerLeft_wrapper">
        <div className="headerLeft_inner_wrapper">
          <div className="hdrTopRight">
            {showBatchLabel ? (
              <p className="text_content_1">
                {!isEmpty(batchDetails)
                  ? "Batch - " + batchDetails.batch
                  : "Batch"}
              </p>
            ) : null}
            <button
              className={`${buttonClassName}${isPreferenceLoading ? " is-loading" : ""}`}
              onClick={handlePreferenceModal}
              disabled={isPreferenceLoading}
              aria-busy={isPreferenceLoading}
            >
              {buttonText}
              <img src={buttonIcon} alt="" />
            </button>
          </div>
        </div>
      </div>
      <PreferenceSelectionModal
        isOpen={isPreferenceModalOpen}
        isLoading={isPreferenceLoading}
        userPreference={state.userPreference}
        targets={state.targets}
        classes={state.classes}
        courses={state.courses}
        batches={state.batches}
        handleChangeTarget={handleChangeTarget}
        handleChangeClass={handleChangeClass}
        handleChangeCourse={handleChangeCourse}
        handleChangeBatch={handleChangeBatch}
        handleUpdateCourse={handleUpdateCourse}
        handleCloseModal={handleCloseModal}
        userData={userData}
      />
    </Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUser: (payload) => {
      dispatch(authActions.setUser(payload));
    },
    setUserPreference: (payload) => {
      dispatch(userPreferenceActions.setUserPreference(payload));
    },
  };
};

export default connect(null, mapDispatchToProps)(HeaderLeft);
